/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Delete_Toast_Success_DescInputs */

const es_sidebar_delete_toast_success_desc = /** @type {(inputs: Sidebar_Delete_Toast_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversación fue eliminada correctamente.`)
};

const en_sidebar_delete_toast_success_desc = /** @type {(inputs: Sidebar_Delete_Toast_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conversation was deleted successfully.`)
};

/**
* | output |
* | --- |
* | "The conversation was deleted successfully." |
*
* @param {Sidebar_Delete_Toast_Success_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const sidebar_delete_toast_success_desc = /** @type {((inputs?: Sidebar_Delete_Toast_Success_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Delete_Toast_Success_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_sidebar_delete_toast_success_desc(inputs)
	return en_sidebar_delete_toast_success_desc(inputs)
});
export { sidebar_delete_toast_success_desc as "sidebar.delete_toast.success_desc" }